import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { filter, map, Observable } from 'rxjs';

import { CORE, CoreState, IAppRootState } from './app.state';
import { CurrentUser } from '../domain/current-user';
import { Features } from '../domain/features';
import { Organization } from '../domain/organization';
import { Preferences } from '../domain/preferences';

@Injectable({
	providedIn: 'root',
})
export class AppSelector {
	public constructor(private readonly store: Store<IAppRootState>) {}

	private get state(): Observable<CoreState> {
		return this.store.pipe(select((store) => store[CORE]));
	}

	public getCurrentOrganization$(): Observable<Organization> {
		return this.state.pipe(
			map((state) => {
				const organizationsForUser = state.get('organizationsForUser');
				return organizationsForUser.get(state.selectedOrganization);
			}),
			filter((o): o is Organization => o !== undefined),
		);
	}

	public getCurrentUser$(): Observable<CurrentUser> {
		return this.state.pipe(map((state) => state.get('currentUser')));
	}

	public getPreferences$(): Observable<Preferences> {
		return this.getCurrentUser$().pipe(map((user) => user.preferences));
	}

	public getDateTimeFormat$(): Observable<string> {
		return this.getPreferences$().pipe(
			map((preferences) => preferences.dateFormat['DateTime']),
		);
	}

	public getDateFormat$(): Observable<string> {
		return this.getPreferences$().pipe(
			map((preferences) => preferences.dateFormat['Date']),
		);
	}

	public getTimeFormat$(): Observable<string> {
		return this.getPreferences$().pipe(
			map((preferences) => preferences.dateFormat['Time']),
		);
	}

	public getFeatures$(): Observable<Features> {
		return this.state.pipe(map((state) => state.get('features')));
	}
}
